module.exports = __webpack_public_path__ + "img/ys-one-grid.198ecd14.png";